import { useEffect, useState } from "react";
import { listUsers } from "../services/usersService";
import { useAppLoading } from "../context/AppLoadingContext";

const DEFAULT_PAGE_SIZE = 12;

export function useAdminUsers(page, pageSize = DEFAULT_PAGE_SIZE, query = "") {
  const { trackAsync } = useAppLoading();
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    page,
    pageSize,
    total: 0,
    totalPages: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [reloadTick, setReloadTick] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const loadUsers = async () => {
      setIsLoading(true);
      setError("");

      try {
        const response = await listUsers({ page, pageSize, q: query });

        if (!isMounted) {
          return;
        }

        setUsers(response.users);
        setPagination(response.pagination);
      } catch (requestError) {
        if (!isMounted) {
          return;
        }

        setError(requestError.message || "No pudimos cargar los usuarios.");
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    void trackAsync(loadUsers);

    return () => {
      isMounted = false;
    };
  }, [page, pageSize, query, reloadTick, trackAsync]);

  const refresh = () => setReloadTick((current) => current + 1);

  return {
    users,
    pagination,
    isLoading,
    error,
    refresh,
  };
}
